import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { useCreateUserWithEmailAndPassword, useUpdateProfile } from 'react-firebase-hooks/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import auth from '../../../firebase.init';
import SocialAuth from '../SocialAuth/SocialAuth';
import background from '../../../images/auth-background.jpg';
import Loading from '../Loading/Loading';

const Register = () => {
    const backgroundImageStyle = {
        backgroundImage: `url(${background})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        zIndex: -1,
        width: '100%',
        // height: '80vh',
        height: '550px',
        opacity: '95%',
        // opacity: '0.25',
        overflow: 'hidden'
    }

    const nameRef = useRef('');
    const emailRef = useRef('');
    const passwordRef = useRef('');

    const [
        createUserWithEmailAndPassword,
        user,
        loading,
        error,
    ] = useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });
    const [updateProfile, updating, profileError] = useUpdateProfile(auth);
    const [error2, setError2] = useState('');
    const navigate = useNavigate();

    if (user) {
        // navigate('/home');
    }

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const name = nameRef.current.value;
        const email = emailRef.current.value;
        const password = passwordRef.current.value;
        // console.log(name, " - ", email, " - ", password);

        if (password.length <= 7) {
            setError2('Password contains at least 8 character long');
            return;
        }

        await createUserWithEmailAndPassword(email, password);
        await updateProfile({ displayName: name });
        toast('Sent Email. Verify your email address');
        navigate('/home');
    }

    return (
        <div style={backgroundImageStyle} className='p-5 d-flex flex-column align-items-center justify-content-center'>
            <h2 className='text-light mb-4'>Register</h2>
            <Form onSubmit={handleFormSubmit} className='form-container'>
                <Form.Group className="mb-3 " controlId="formBasicName">
                    <Form.Control ref={nameRef} className='inputID text-light bg-light bg-opacity-25' type="text" placeholder="Name" required/>
                </Form.Group>

                <Form.Group className="mb-3 " controlId="formBasicEmail">
                    <Form.Control ref={emailRef} className='inputID text-light bg-light bg-opacity-25' type="email" placeholder="Email" required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control ref={passwordRef} className='inputID text-light bg-light bg-opacity-25' type="password" placeholder="Password" required/>
                </Form.Group>

                {
                    (error || error2 || profileError) && <p className='text-danger text-center'>{error?.message} {error2} {profileError?.message}</p>
                }
                {
                    (loading || updating) && <Loading></Loading>
                }

                <Button variant="outline-success" type="submit" className='w-100 text-light'>
                    Register
                </Button>
            </Form>
            <Link to='/login' className='text-decoration-none mt-2 text-primary'>Already have an account?</Link>
            <SocialAuth></SocialAuth>
            <ToastContainer></ToastContainer>
        </div>
    );
};

export default Register;